export const TIMESTAMP = 'timestamp';
export const LIKES = 'likes';
export const RATINGS = 'rating';
export const VIEWS = 'views';
export const FEATURED_INDEX = 'featuredIndex';
export const ASCENDING = 'asc';
export const DESCENDING = 'desc';
